export default [
    {
        path: '/local-guides',
        name: 'local-guides',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Users/LocalGuides.vue')
    }
]